import { arrayPushUnique } from '../../../../core/util/array-push-unique';
import { omit } from '../../../../core/util/utils';
import { Group } from '../../../../vas/business-objects/group/group.model';
import * as actions from '../form-manager-page.actions';
import { initialState, State } from '../form-manager-page.reducer';

export const formRemoveReducer = (
    state = initialState,
    action: actions.FormRemove
): State => {
    if (!state.form.ids.find(id => id === action.payload.form.id)) {
        return state;
    }

    const dirtyGroupIds = state.group.ids
        .filter(id => {
            const group = state.group.entities[id];
            return group.forms.indexOf(action.payload.form.id) !== -1;
        });

    return {
        ...state,
        dirty: true,
        dirtyIds: {
            ...state.dirtyIds,
            groups: dirtyGroupIds.reduce(
                (acc, id) => arrayPushUnique(acc, id),
                state.dirtyIds.groups
            )
        },
        form: {
            ...state.form,
            ids: state.form.ids
                .filter(id => id !== action.payload.form.id),
            entities: omit(
                state.form.entities,
                action.payload.form.id
            ),
            deleted: [...state.form.deleted, action.payload.form]
        },
        group: {
            ...state.group,

            entities: state.group.ids
                .map(id => {
                    const group = state.group.entities[id];
                    return new Group({
                        ...group,
                        forms: group.forms
                            .filter(
                                gid =>
                                    gid !== action.payload.form.id
                            )
                    });
                })
                .reduce((groups, group) => {
                    groups[group.id] = group;
                    return groups;
                }, {})
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/reducers/form-remove.reducer.ts